import React from 'react';
import { Grid, Paper, Button } from '@mui/material';
import CreatingAccount from './CreatingAccount/View';
import CompanyData from './CompanyData/View';
import PaymentInformation from './PaymentInformation/view';
import StepperMenu from './StepperMenu/view';
import PremiumPaymentViewModel from './view.model';
import SuccessCreateAccount from './SuccessCreateAccount/view';

function PremiumPayment() {

  const {
    activeStep,
    steps,
    nextStepper,
    backStepper,
    paymentType,
    handlePaymentTypeChange,
    handleChangeAccount,
    formValues,
    disabledButton,
    sliderValue,
    employeer,
    addressEmployeer,
    marks,
    handleChangeEmployeer,
    handleChangeAddress,
    handleChangeSlider,
    plan,
    selectedPlan,
    planData,
    handleChangePlan,
    creatingAccount,
    activeErrorPassword,
    errorPassword,
    validateErrosPassword,
    activeValidEmail,
    validEmail,
    validarEmail,
    activeErrorCNJ,
    errorCNJ,
    personData,
    errorGeneric
  } = PremiumPaymentViewModel();

  function getStepContent(stepIndex) {
    switch (stepIndex) {
      case 0:
        return <CreatingAccount
          formValues={formValues}
          errorPassword={errorPassword}
          handleChangeAccount={handleChangeAccount}
          activeErrorPassword={activeErrorPassword}
          validateErrosPassword={validateErrosPassword}
          errorGeneric={errorGeneric}
          activeValidEmail={activeValidEmail}
          validEmail={validEmail}
          validarEmail={validarEmail}
        />;
      case 1:
        return <CompanyData
          marks={marks}
          errorCNJ={errorCNJ}
          employeer={employeer}
          sliderValue={sliderValue}
          activeErrorCNJ={activeErrorCNJ}
          addressEmployeer={addressEmployeer}
          handleChangeSlider={handleChangeSlider}
          handleChangeAddress={handleChangeAddress}
          handleChangeEmployeer={handleChangeEmployeer}
          errorGeneric={errorGeneric}
        />;
      case 2:
        return <SuccessCreateAccount
          personData={personData}
          selectedPlan={selectedPlan}
          planData={planData}
        />;
    }
  }

  return (
    <Paper style={{ backgroundColor: '#fafafa', margin: '20px 20px 1px 20px', display: 'flex', justifyContent: 'center' }} elevation={0} >

      <Grid style={{ maxWidth: '1200px' }}>

        <StepperMenu activeStep={activeStep} steps={steps} />

        <Grid container style={{ display: 'flex', flexDirection: 'row', marginTop: '10px', backgroundColor: '#fafafa', boxShadow: '-8px 20px 18px rgba(0, 0, 0, 0.1)', borderTopLeftRadius: '49px' }}>

          <Grid item xs={8}>
            <Paper style={{ borderTopLeftRadius: 50, height: '100%', width: '100%' }}>

              <Grid style={{ height: '80%' }}>
                {getStepContent(activeStep)}
              </Grid>
              {activeStep < 2 ?
                <Grid style={{ width: '100%', display: 'flex', justifyContent: 'flex-end', paddingRight: '44px', paddingBottom: '55px' }}>
                  {activeStep > 0 ?
                    <Grid>
                      <Button
                        style={{ backgroundColor: '#3a3a3a', ...styles.buttonNextBack }}
                        onClick={backStepper}>Voltar</Button>
                    </Grid> : ''}
                  <Grid>
                    <Button
                      disabled={disabledButton}
                      style={{ backgroundColor: disabledButton ? '#d1d1d1' : '#4a50de', ...styles.buttonNextBack }}
                      onClick={activeStep === 1 ? creatingAccount : nextStepper}>
                      Continuar
                    </Button>
                  </Grid>
                </Grid> : ''
              }
            </Paper>
          </Grid>

          <PaymentInformation activeStep={activeStep} plan={plan} selectedPlan={selectedPlan} handleChangePlan={handleChangePlan} paymentType={paymentType} handlePaymentTypeChange={handlePaymentTypeChange} />

        </Grid >
      </Grid >
    </Paper >
  )
}

export default PremiumPayment;

const styles = ({
  buttonTicket: {
    height: '40',
    color: 'gray',
    borderStyle: 'solid',
    borderWidth: '1px',
    backgroundColor: '#FFFF',
    borderRadius: '50px',
    paddingInline: '50px',
    margin: '10px',
    marginTop: '40px',
    textTransform: 'none',
    fontFamily: 'Heebo',
    fontWeight: 600,
    fontSize: 20
  },
  buttonNextBack: {
    height: '40',
    color: '#FFFF',
    borderRadius: '50px',
    paddingInline: '25px',
    margin: '10px',
    marginTop: '40px',
    textTransform: 'none',
    fontFamily: 'Heebo',
    fontWeight: 600,
    fontSize: 20
  },

});
